import { createAction } from 'redux-actions';
import { createRequestActions } from '../utils';
import * as ingredientTypes from './ingredientTypes';

export const listIngredients = createRequestActions(ingredientTypes.INGREDIENT_LIST);
export const ingredient = createRequestActions(ingredientTypes.INGREDIENT);
export const saveIngredient = createRequestActions(ingredientTypes.SAVE_INGREDIENT);

export const newIngredient = createAction(ingredientTypes.NEW_INGREDIENT);
